function setTruckColor(situation) {
    let colors = 'orange';

    switch (situation) {
        case 'Objeto postado':
        case 'EMISSAO':
            colors = '#03A9F4';
            break;
        case 'EM ROTA':
        case 'Objeto saiu para entrega ao destinatário':
            colors = '#c5c517';
            break;
        case 'ENTREGUE':
        case 'Objeto entregue ao destinatário':
            colors = '#03F463';
            break;
        case 'Endereço incorreto - Entrega não realizada':
            colors = '#F42003';
            break;
        default:
            colors = '#F49403';
            break;
    }

    return colors;
}

export default setTruckColor;
